import { GET_VFO_TRACKING } from "../../../Types";
// import _ from 'lodash'
const VfoTrackReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VFO_TRACKING:
      return action.payload;
    default:
      return state;
  }
};
export default VfoTrackReportReducer;
